<template>
    <div id="zoom-marker-holder">
      <img class="zoom-marker-img" id="zoom-marker-img" alt="zoom-marker-img" name="zoom-marker-img" draggable="false"/>
    </div>
</template>

<script>
    

    export default {
        props: [
            'imgData',
            'markerPosition',
            'markerNumber'
        ],
        watch: { 
          imgData: function(newVal, oldVal) {
            console.log('Value of imgData changed');
            $('#zoom-marker-img').zoomMarker_CleanMarker();
            $('#zoom-marker-img').zoomMarker_LoadImage(newVal);
            this.addedMarkers = [];
            this.$emit('update-marker', {
              x: null,
              y: null
            });
          }
        },
        data() {
            return {
              addedMarkers: []
            }
        },
        methods: {
          getZoomLevel() {
            return $('#zoom-marker-img').width() / $('#zoom-marker-holder').width();
          },
        },
        computed: {

        },
        mounted () {
          console.log('SitePlanMarker Mounted');
          if(this.markerPosition) {
            this.addedMarkers.push(
              {
                src: '/img/issue-marker.svg',
                x: this.markerPosition.position_x,
                y: this.markerPosition.position_y,
                draggable: true,
                size: 45,
                hint: {value: this.markerNumber, style:{color:"#ffffff"}}
              }
            );
          }

          var self = this;

          $('#zoom-marker-img').zoomMarker({
              src: self.imgData,
              rate: 0.2,
              width: $('#zoom-marker-holder').width(),
              max: 3000,
              markers: self.addedMarkers,
              move_limit: false
          });

          if(this.markerPosition && this.markerPosition.zoom > 1) {
            $('#zoom-marker-img').on('zoom_marker_img_loaded', function() {
              $('#zoom-marker-img').zoomMarker_Zoom({
                x: self.markerPosition.position_x,
                y: self.markerPosition.position_y
              }, self.markerPosition.zoom);
            });
          }

          $('#zoom-marker-img').on('zoom_marker_mouse_click', function(event, position) {
            if(self.addedMarkers) {
              $('#zoom-marker-img').zoomMarker_CleanMarker();
              self.addedMarkers = [];
            }

            self.addedMarkers.push(
              {
                src: '/img/issue-marker.svg',
                x: position.x,
                y: position.y,
                draggable: true,
                size: 45,
                hint:{value: self.markerNumber, style:{color:"#ffffff"}}
              }
            );

            $('#zoom-marker-img').zoomMarker_AddMarker(self.addedMarkers[0]);
            self.$emit('update-marker', self.addedMarkers[0]);
          });

          $('#zoom-marker-img').on("zoom_marker_move_end", function(event, position){
            self.addedMarkers[0].x = position.x;
            self.addedMarkers[0].y = position.y;
            self.$emit('update-marker', self.addedMarkers[0]);
          });

          // $(this.$el).datepicker({
          //   dateFormat: this.dateFormat,
          //   onSelect: function(date) {
          //     self.$emit('update-date', date);
          //   }
          // });
        }
    }
</script>